"use strict";

define(['app', './base'], function (app, Helper) {
  return Helper.extend({
    options: {
      time: 500
    },
    initialize: function initialize() {
      if (this.$el.length) {
        app.$('html, body').animate({
          scrollTop: this.$el.offset().top
        }, this.getOption('time'));
      }
    }
  });
});